import { jsPDF } from "jspdf";
import { api } from "@/lib/api";

const PW = 3508;
const PH = 2480;
const M = 80;

const loadImg = (src) => new Promise((ok, ko) => { const i = new Image(); i.onload = () => ok(i); i.onerror = ko; i.src = src; });

async function blobImg(url) {
  try {
    const r = await api.get(url, { responseType: "blob" });
    const src = URL.createObjectURL(r.data);
    const img = await loadImg(src);
    return img;
  } catch {
    return null;
  }
}

function fit(ctx, img, x, y, w, h) {
  const k = Math.min(w / img.width, h / img.height);
  const dw = img.width * k;
  const dh = img.height * k;
  ctx.drawImage(img, x + (w - dw) / 2, y + (h - dh) / 2, dw, dh);
}

function clip(ctx, text, max) {
  let t = text;
  while (t.length > 3 && ctx.measureText(t).width > max) t = t.slice(0, -1);
  return t === text ? t : `${t.trim()}…`;
}

export async function planToA4Pdf({ mapBlob, mapUrl, title, subtitle, note, logoUrl, fileName }) {
  const c = document.createElement("canvas");
  c.width = PW;
  c.height = PH;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#fff";
  ctx.fillRect(0, 0, PW, PH);
  const logo = logoUrl ? await blobImg(logoUrl) : null;
  const logoW = logo ? 520 : 0;
  if (logo) fit(ctx, logo, PW - M - logoW, M - 10, logoW, 190);
  ctx.fillStyle = "#0D2B3A";
  ctx.textBaseline = "top";
  ctx.font = "italic 600 104px 'Cormorant Garamond', Georgia, serif";
  ctx.fillText(clip(ctx, title, PW - 2 * M - logoW - 60), M, M);
  ctx.fillStyle = "#5A7380";
  ctx.font = "500 48px 'Plus Jakarta Sans', Arial, sans-serif";
  ctx.fillText(clip(ctx, subtitle, PW - 2 * M - logoW - 60), M, M + 128);
  const top = M + 205;
  ctx.fillStyle = "#0D2B3A";
  ctx.fillRect(M, top, PW - 2 * M, 5);
  const foot = PH - M - 34;
  ctx.fillStyle = "#7B929C";
  ctx.font = "400 38px 'Plus Jakarta Sans', Arial, sans-serif";
  ctx.fillText(note, M, foot);
  const map = mapBlob ? await loadImg(URL.createObjectURL(mapBlob)) : await blobImg(mapUrl);
  if (map) fit(ctx, map, M, top + 20, PW - 2 * M, foot - top - 40);
  const pdf = new jsPDF({ orientation: "landscape", unit: "mm", format: "a4" });
  pdf.addImage(c.toDataURL("image/jpeg", 0.92), "JPEG", 0, 0, 297, 210);
  pdf.save(fileName);
}
